import { createAction } from '@ngrx/store';

export const switchState = createAction('Switch sidebar state');
export const toggleOn = createAction('Toggle mini sidebar to on');
export const toggleOff = createAction('Toggle mini sidebar to off');